import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import RandomizeIcon from '@atlaskit/icon-lab/core/randomize';
import { ToolbarButton, ToolbarButtonGroup, ToolbarTooltip } from '@atlaskit/editor-toolbar';

const messages = defineMessages({
	remixLabel: {
		id: 'highlight-actions.remix-action.toolbar-label',
		defaultMessage: 'Remix',
		description: 'Label for the Remix button in the highlight actions floating toolbar',
	},
});

export const RemixAction = ({
	isNewToolbarEnabled,
	onClick,
}: {
	isNewToolbarEnabled?: boolean;
	onClick?: () => void;
}) => {
	const { formatMessage } = useIntl();

	return isNewToolbarEnabled ? (
		<ToolbarTooltip content={formatMessage(messages.remixLabel)}>
			<ToolbarButtonGroup>
				<ToolbarButton
					iconBefore={<RandomizeIcon label="" size="small" />}
					testId="highlight-actions-remix"
					onClick={onClick}
				>
					<FormattedMessage {...messages.remixLabel} />
				</ToolbarButton>
			</ToolbarButtonGroup>
		</ToolbarTooltip>
	) : (
		<ToolbarTooltip content={formatMessage(messages.remixLabel)}>
			<Button
				appearance="subtle"
				iconBefore={RandomizeIcon}
				testId="highlight-actions-remix"
				onClick={onClick}
			>
				<FormattedMessage {...messages.remixLabel} />
			</Button>
		</ToolbarTooltip>
	);
};
